export default __webpack_public_path__ + "static/media/koffing.ee6a6d1c.png";